var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertDriverUber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.102 60.056v4.204c0 2.07 1.689 3.74 3.767 3.74h34.766c2.087 0 3.768-1.677 3.768-3.74v-4.204H13.102zM55.411 7.944V3.74c0-2.07-1.69-3.74-3.768-3.74H16.877c-2.086 0-3.775 1.677-3.775 3.74v4.204H55.41z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC040",
    d: "M55.411 7.944h-42.31v52.112h42.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.258 66.207a1.97 1.97 0 0 0 1.978-1.962 1.97 1.97 0 0 0-1.977-1.963 1.97 1.97 0 0 0-1.978 1.963 1.97 1.97 0 0 0 1.977 1.962z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 25.384a4.62 4.62 0 0 1-6.493 0 4.537 4.537 0 0 1 0-6.445 4.62 4.62 0 0 1 6.493 0 4.537 4.537 0 0 1 0 6.445z",
    fill: "#FFDFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 34.502a4.62 4.62 0 0 1-6.493 0 4.537 4.537 0 0 1 0-6.444 4.62 4.62 0 0 1 6.493 0 4.537 4.537 0 0 1 0 6.444z",
    fill: "#FFDFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 43.62a4.62 4.62 0 0 1-6.493 0 4.537 4.537 0 0 1 0-6.444 4.62 4.62 0 0 1 6.493 0 4.537 4.537 0 0 1 0 6.444z",
    fill: "#FFDFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.656 52.739a4.62 4.62 0 0 1-6.493 0 4.537 4.537 0 0 1 0-6.445 4.62 4.62 0 0 1 6.493 0 4.537 4.537 0 0 1 0 6.445zM21.579 55.86V68H0V39.363c0-3.315 1.059-6.538 3.028-9.211l9.56-12.982a1.792 1.792 0 0 1 2.538-.348 7.558 7.558 0 0 1 2 9.62l-2.95 5.356v12.317l.311.162a13.138 13.138 0 0 1 5.185 4.807 12.92 12.92 0 0 1 1.907 6.776z",
    fill: "#FFDFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.277 22.409c0-1.661 1.347-2.913 3.02-2.913 1.675 0 2.936 1.252 2.936 2.913 0 1.661-1.261 2.952-2.935 2.952-1.674 0-3.02-1.298-3.02-2.952zm5.667 26.095h-5.34V29.626h5.34v18.878z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertDriverUber);
export default __webpack_public_path__ + "static/media/ico-alert-driver-uber.4e01b7cb1e23792a2e727de17e3f1e04.svg";
export { ForwardRef as ReactComponent };